<template>
  <div class="podcastList">
    <div class="podcastList-con">
      <div class="cg-mainWrapper">
        <h2 class="mod-title" :class="{'rtl':isAR}">
          <span>{{columnName}}</span>
        </h2>
      </div>
      <div class="picTopW370H370">
        <div class="cg-mainWrapper">
          <div class="picTopW370H370-pc-con clearfloat js-lane-height">
            <dl v-for="(item,key) in columnList" :class="{'rtl':item.groupName === 'ar'}" :key="key">
              <dt>
                <aLink :toPath="item.url"><img v-lazy="{src:item.picurl,loading:require('../../static/img/loading/loading-1-1.jpg'),error:require('../../static/img/loading/loading-1-1.jpg')}" alt=""></aLink>
              </dt>
              <dd>
                <h3><aLink :toPath="item.url">{{item.programTitle}}</aLink></h3>
                <p>{{item.info}}</p>
                <div class="btn-noBorder js-play play" :data-playcolumnId="item.columnId" :data-pic="item.sharePicurl" :data-showName="item.shareTitle" :data-linkUrl="item.shareUrl" :data-url="item.mediaUrl" data-type="mp3" :data-countryCode="item.countryRegionLimit" :data-groupName="item.groupName" @click="play($event)"><div class="icon">{{item.duration}}</div></div>
                <aLink :toPath="item.url" class="more">
                  <i></i>
                  <span v-if="item.groupName === 'fr'">Plus d'épisodes</span>
                  <span v-else>MORE EPISODES</span>
                </aLink>
              </dd>
            </dl>
          </div>
          <div class="picTopW370H370-m-con">
            <div class="news-ul">
              <div class="news-item" v-for="(item,key) in columnList" :class="{'rtl':item.groupName === 'ar'}" :key="key">
                <div class="info">
                  <div class="pic">
                    <img v-lazy="{src:item.picurl,loading:require('../../static/img/loading/loading-1-1.jpg'),error:require('../../static/img/loading/loading-1-1.jpg')}" alt="">
                    <aLink :toPath="item.url" class="pic-mask"></aLink>
                  </div>
                  <div class="txt">
                    <h3><aLink :toPath="item.url">{{item.programTitle}}</aLink></h3>
                    <p>{{item.info}}</p>
                    <div class="btn-border js-play play" :data-playcolumnId="item.columnId" :data-pic="item.sharePicurl" :data-showName="item.shareTitle" :data-linkUrl="item.shareUrl" :data-url="item.mediaUrl" data-type="mp3" :data-countryCode="item.countryRegionLimit" :data-groupName="item.groupName" @click="play($event)"><div class="icon">LISTEN</div><div>{{item.duration}}</div></div>
                  </div>
                </div>
                <div class="more">
                  <aLink :toPath="item.url" class="more">
                    <i></i>
                    <span v-if="item.groupName === 'fr'">Plus d'épisodes</span>
                    <span v-else>MORE EPISODES</span>
                  </aLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'podcastList',
  data () {
    return {
      columnName:'',
      columnId:null,
      columnList:[],
      columnClassItems:{
        xhrUrl:'/api/api/v2/programGroupRelation',
        xhrParam:{
          'groupId':'',
        },
      },
      typeObjUrl:{
        ezfm:"/podcast/column",
        other:"/podcast/column",
        recommend:"/news",
        ezfmHistory:"/podcast/news",
        otherHistory:"/podcast/news",
        more:"/news",
        lane:"/laneList",
        linkUrl:'',
      },
      typeObjNum: {
        ezfm: 1,
        selection: 2,
        ezfmSelection:2,
        recommend: 3,
        more: 4,
        other: 5,
        otherSelection: 6,
        otherHistory: 5,
        ezfmHistory: 1,
      },
      sessionCountryCode:'',
      isAR:false,
      clientWidth:document.documentElement.clientWidth,
    }
  },
  methods:{
    getParams(){
      var _this = this;
      _this.columnId = _this.$route.params.pColumnId;
      _this.columnClassItems.xhrParam.groupId = _this.columnId;
      if(_this.columnId === '17'){
        _this.isAR = true;
      }
    },
    getColumnClassItems(){
      var _this = this , data = [] , urlTitle = '' , _url = '' , firstColumnData = {};
      _this.$get('/api/api/v2/programGroupRelation?groupId='+_this.columnId+'',{},_this).then((response)=>{
        if(response.data.data){
          data = response.data.data;
          _this.columnName = data[0].programGroupName;
          $('title').text(data[0].programGroupName+' | CGTN Radio');
          $("meta[name='description']").attr('content','Find your favorite podcasts, including news, business, politics, music, culture, and more. Listen and subscribe to CGTN Radio right now!');
          $("meta[name='keywords']").attr('content','radio, live radio, shows, podcasts, news, radio news, world news, China news, business, politics, talk, audiobooks, arts, music, learning, Español, Français, Русский, Arabic');
          $("meta[property='og:url']").attr('content',''+window.location.href+'')
          $("meta[property='og:title']").attr('content',''+data[0].programGroupName+' | CGTN Radio');
          $("meta[property='og:description']").attr('content','Find your favorite podcasts, including news, business, politics, music, culture, and more. Listen and subscribe to CGTN Radio right now!');
          $("meta[property='og:image']").attr('content',''+data[0].columnPicurl1+'?x-oss-process=image/resize,w_600/crop,g_north,w_600,h_315');

          $("meta[name='twitter:title']").attr('content',''+data[0].programGroupName+' | CGTN Radio');
          $("meta[name='twitter:description']").attr('content','Find your favorite podcasts, including news, business, politics, music, culture, and more. Listen and subscribe to CGTN Radio right now!');
          $("meta[name='twitter:image']").attr('content',''+data[0].columnPicurl1+'?x-oss-process=image/resize,w_600/crop,g_north,w_600,h_315');

          $("meta[name='apple-mobile-web-app-title']").attr('content',''+data[0].programGroupName+' | CGTN Radio');
          $(".shareBrowserPic img").attr('src',data[0].columnPicurl1+'?x-oss-process=image/resize,w_300');
          for(var i=0;i<data.length;i++){
            // urlTitle = data[i].programTitle.replace(/[\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?]/g,"");
            // urlTitle = urlTitle.split(' ').join('-');
            urlTitle = _this.filterUrl(data[i].programTitle);
            if(data[i].programType == 'ezfm' || data[i].programType == 'other'){//栏目列表
              _url = _this.typeObjUrl[data[i].programType]+'/'+data[i].programType+'/'+urlTitle+'/'+data[i].programId;
              data[i].url = _url;
              if('groupName' in data[i]){
                data[i].groupName = data[i].groupName;
              }else{
                data[i].groupName = '';
              }
              // 取栏目下的第一条数据
              if('onair' in data[i] && data[i].onair){
                firstColumnData = data[i].onair;
                if('columnPicurl1' in data[i] && data[i].columnPicurl1){
                  firstColumnData.picurl1 = data[i].columnPicurl1;
                }else{
                  firstColumnData.picurl1 = data[i].picurl;
                }
                data[i].info = firstColumnData.title;
                data[i].mediaUrl = firstColumnData.mediaUrl;
                data[i].countryRegionLimit = firstColumnData.countryRegionLimit;
                if(data[i].mediaUrl){
                  data[i].mediaUrl = data[i].mediaUrl.replace('http://resezfm.meldingcloud.com','https://radio-res.cgtn.com');
                  data[i].mediaUrl = data[i].mediaUrl.replace('http://podcasts-cri.meldingcloud.com','https://radio-wdsl.cgtn.com');
                }
                data[i].duration = firstColumnData.duration;
                data[i].picurl = firstColumnData.picurl1;

                data[i].sharePicurl = firstColumnData.picurl;
                data[i].shareTitle = firstColumnData.title;
                urlTitle = _this.filterUrl(firstColumnData.title);
                data[i].shareUrl = 'https://radio.cgtn.com/podcast/news/' + _this.typeObjNum[data[i].programType] + '/' + urlTitle + '/' + firstColumnData.id;

                if(data[i].countryRegionLimit && _this.sessionCountryCode){
                  if(data[i].countryRegionLimit.indexOf(_this.sessionCountryCode) != -1){
                    data[i].mediaUrl = '';
                  }
                }
              }
            }
          }
          _this.columnList = data;
          if(_this.clientWidth > 768){
            setTimeout(function(){
            _this.itemHeight();
          },200)
          }
        }
      })
    },
    getColumnClassItems_static(){
      var _this = this , data = [] , urlTitle = '' , _url = '' , firstColumnData = {};
      _this.$get('/downapiRES/radio/v1/programGroupRelation/groupId'+_this.columnId+'.json',{},_this).then((response)=>{
        if(response.data.data){
          data = response.data.data;
          _this.columnName = data[0].programGroupName;
          $('title').text(data[0].programGroupName+' | CGTN Radio');
          $("meta[name='description']").attr('content','Find your favorite podcasts, including news, business, politics, music, culture, and more. Listen and subscribe to CGTN Radio right now!');
          $("meta[name='keywords']").attr('content','radio, live radio, shows, podcasts, news, radio news, world news, China news, business, politics, talk, audiobooks, arts, music, learning, Español, Français, Русский, Arabic');
          $("meta[property='og:url']").attr('content',''+window.location.href+'')
          $("meta[property='og:title']").attr('content',''+data[0].programGroupName+' | CGTN Radio');
          $("meta[property='og:description']").attr('content','Find your favorite podcasts, including news, business, politics, music, culture, and more. Listen and subscribe to CGTN Radio right now!');
          $("meta[property='og:image']").attr('content',''+data[0].columnPicurl1+'?x-oss-process=image/resize,w_600/crop,g_north,w_600,h_315');

          $("meta[name='twitter:title']").attr('content',''+data[0].programGroupName+' | CGTN Radio');
          $("meta[name='twitter:description']").attr('content','Find your favorite podcasts, including news, business, politics, music, culture, and more. Listen and subscribe to CGTN Radio right now!');
          $("meta[name='twitter:image']").attr('content',''+data[0].columnPicurl1+'?x-oss-process=image/resize,w_600/crop,g_north,w_600,h_315');

          $("meta[name='apple-mobile-web-app-title']").attr('content',''+data[0].programGroupName+' | CGTN Radio');
          $(".shareBrowserPic img").attr('src',data[0].columnPicurl1+'?x-oss-process=image/resize,w_300');
          for(var i=0;i<data.length;i++){
            // urlTitle = data[i].programTitle.replace(/[\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?]/g,"");
            // urlTitle = urlTitle.split(' ').join('-');
            urlTitle = _this.filterUrl(data[i].programTitle);
            if(data[i].programType == 'ezfm' || data[i].programType == 'other'){//栏目列表
              _url = _this.typeObjUrl[data[i].programType]+'/'+data[i].programType+'/'+urlTitle+'/'+data[i].programId;
              data[i].url = _url;
              if('groupName' in data[i]){
                data[i].groupName = data[i].groupName;
              }else{
                data[i].groupName = '';
              }
              // 取栏目下的第一条数据
              if('onair' in data[i] && data[i].onair){
                firstColumnData = data[i].onair;
                if('columnPicurl1' in data[i] && data[i].columnPicurl1){
                  firstColumnData.picurl1 = data[i].columnPicurl1;
                }else{
                  firstColumnData.picurl1 = data[i].picurl;
                }
                data[i].info = firstColumnData.title;
                data[i].mediaUrl = firstColumnData.mediaUrl;
                data[i].countryRegionLimit = firstColumnData.countryRegionLimit;
                if(data[i].mediaUrl){
                  data[i].mediaUrl = data[i].mediaUrl.replace('http://resezfm.meldingcloud.com','https://radio-res.cgtn.com');
                  data[i].mediaUrl = data[i].mediaUrl.replace('http://podcasts-cri.meldingcloud.com','https://radio-wdsl.cgtn.com');
                }
                data[i].duration = firstColumnData.duration;
                data[i].picurl = firstColumnData.picurl1;

                data[i].sharePicurl = firstColumnData.picurl;
                data[i].shareTitle = firstColumnData.title;
                urlTitle = _this.filterUrl(firstColumnData.title);
                data[i].shareUrl = 'https://radio.cgtn.com/podcast/news/' + _this.typeObjNum[data[i].programType] + '/' + urlTitle + '/' + firstColumnData.id;

                if(data[i].countryRegionLimit && _this.sessionCountryCode){
                  if(data[i].countryRegionLimit.indexOf(_this.sessionCountryCode) != -1){
                    data[i].mediaUrl = '';
                  }
                }
              }
            }
          }
          _this.columnList = data;
          if(_this.clientWidth > 768){
            setTimeout(function(){
            _this.itemHeight();
          },200)
          }
        }
      })
    },
    itemHeight(paramEl){
      var _this = this , modEl , el , flagNum;
      _this.$nextTick(function(){
        modEl = $('.js-lane-height');
        for(var i=0;i<modEl.length;i++){
          if(modEl.eq(i).hasClass('index-fivePic-con')){
            _this.clientWidth <= 1260 ? flagNum = 4 : flagNum = 5;
          }else if(modEl.eq(i).hasClass('index-fourPic-con')){
            _this.clientWidth <= 1260 ? flagNum = 2 : flagNum = 4;
          }else if(modEl.eq(i).hasClass('picTopW275H275-pc-con')){
            _this.clientWidth <= 1260 ? flagNum = 4 : flagNum = 5;
          }else if(modEl.eq(i).hasClass('picTopW370H370-pc-con')){
            _this.clientWidth <= 1260 ? flagNum = 4 : flagNum = 4;
          }
          el = modEl.eq(i).find('dl');
          var fivePicHeightArr = [];
          var fivePicEltArr = [];
          if(el.length > 0){
            for(var fivePicIndexOne=1;fivePicIndexOne<=el.length;fivePicIndexOne++){
              if(fivePicIndexOne % flagNum == 1){
                var a = [];
                var b = [];
                fivePicHeightArr.push(a);
                fivePicEltArr.push(b);
              }
              a.push(el.eq(fivePicIndexOne-1).find('dd h3').height());
              b.push(el.eq(fivePicIndexOne-1));
            }
            if(fivePicHeightArr){
              for(var fivePicIndexTwo=0;fivePicIndexTwo<fivePicHeightArr.length;fivePicIndexTwo++){
                if(fivePicEltArr){
                  for(var fivePicIndexThree=0;fivePicIndexThree<fivePicEltArr[fivePicIndexTwo].length;fivePicIndexThree++){
                    fivePicEltArr[fivePicIndexTwo][fivePicIndexThree].find('dd h3').css('height',Math.max.apply(null,fivePicHeightArr[fivePicIndexTwo])+'px')
                  }
                }
              }
            }
          }
        }
      })
    },
    play(event,newsData){
      var _this = this , el = $(event.currentTarget) , pages = [] , player;
      pages = _this.$parent.$children;
      for(var i=0;i<pages.length;i++){
        if($(pages[i].$el).hasClass('player')){
          pages[i].audioPlay(el,true,newsData);
        }
      }
    },
    getSessionCountryCode(){
      var _this = this;
      if(sessionStorage.getItem('countryCode') != null){
          _this.sessionCountryCode = sessionStorage.getItem("countryCode")
      }else{
          _this.sessionCountryCode = '';
      }
    },
    reqInit(){
      var _this = this;
      if(_this.isStaticRequest){
        console.log('静态')
        _this.getColumnClassItems_static();
      }else{
        console.log('动态')
        _this.getColumnClassItems();
      }
    },
  },
  created(){
    // this.getParams();
    // this.reqInit();
  },
  mounted(){
    
  },
  activated(){
    this.getSessionCountryCode();
    this.getParams();
    this.reqInit();
  },
}
</script>


<style scoped lang="scss">
.podcastList{
  overflow: hidden;
  border-top: 1px solid #dddddd;
  .podcastList-con{
    margin-top: 34px;
  }
}
@media screen and (max-width: 1560px) and (min-width: 1261px) {
  .podcastList{
    
  }
}
@media screen and (max-width: 1260px) and (min-width: 769px) {
  .podcastList{
    .podcastList-con{
      margin-top: 29px;
    }
    
  }
}
@media screen and (max-width: 768px) {
  .podcastList{
    .podcastList-con{
      margin-top: 1.33rem;
    }
    
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/PodcastList.vue